import React from 'react';

//

const lazyDependencies = {
  OopsPage: React.lazy(() => import('../../../pages/oops')),
  SkillAnswersPage: React.lazy(() => import('../../../pages/skill-answers')),
  SkillPreviewPage: React.lazy(() => import('../../../pages/skill-preview')),
  StandardsResultsPage: React.lazy(() => import('../../../pages/standards-results')),
  StandaloneAssessmentPage: React.lazy(() => import('../../../pages/standalone-assessment')),
  UnsupportedRolePage: React.lazy(() => import('../../../pages/unsupported-role')),
};

// Exports
// -------

export default lazyDependencies;
